<div class="dialog-title mat-tab-label-active text-muted font-family px-3">
  <div>{{"margin-calculator"|translate}}</div>

  <div>
    <button cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle mat-icon-button class="drag-handler text-center" style="cursor: grab;">
      <mat-icon style="font-size: 18px;">open_with</mat-icon>
    </button>
    <button mat-icon-button class="text-center" mat-dialog-close>
      <mat-icon style="font-size: 18px;">close</mat-icon>
    </button>
  </div>
</div>

<!-- <mat-tab-group mat-stretch-tabs [(selectedIndex)]='tabIndex'>

  <mat-tab>
    <ng-template mat-tab-label>
      <span class="sell">{{"sell"|translate}}</span>
    </ng-template>
    <div class="d-flex justify-content-between" id="dark">
      <div class="market-trade-buy">
        <div class="row mt-4 mb-2">
          <div class="col-md-6">
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text" style="border-radius:5px">{{"portfolio"|translate}}</span>
              </div>
              <input style="border-radius:5px" name="ClientPortfolio" [(ngModel)]="marginCalculator.ClientPortfolio" class="form-control">
            </div>
          </div>

          <div class="col-md-6">
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text" style="border-radius:5px">{{"balance"|translate}}</span>
              </div>
              <input style="border-radius:5px" name="BookBalance" [(ngModel)]="marginCalculator.BookBalance" class="form-control" disabled>
            </div>
          </div>
        </div>
        <div class="row mt-4 mb-2">
          <div class="col-md-6">
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text" style="border-radius:5px">{{"margin"|translate}}%</span>
              </div>
              <input style="border-radius:5px" value="80" class="form-control">
            </div>
          </div>

          <div class="col-md-6">
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text" style="border-radius:5px">{{"required"|translate}}%</span>
              </div>
              <input style="border-radius:5px" [(ngModel)]="requiredSell" class="form-control" disabled>
            </div>
          </div>
        </div>
        <button type="button" (click)="calculateSell()" class="btn btn-success text-center mr-1">
          {{' calculate'|translate}}</button>
        <button type="button" class="btn btn-success text-center" (click)="resetCalculator()">
          {{'reset'|translate}}</button>

        <hr style="background: #6c757d!important;">

        <div class="row">
          <div class="col-md-8 d-flex flex-column">
            <div class="pb-1" style="font-weight:500; text-align: start;">
              {{'sell-value'|translate}}
            </div>
            <div style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; text-align: start;">
              {{'deposit-value'|translate}}
            </div>
          </div>
          <div class="col-md-4 d-flex flex-column">
            <div class="pb-1" style="text-align: end !important;">
              {{marginCalculator.Sell|number: "1.0":"en-US"}}
            </div>
            <div style="text-align: end !important;">
              {{marginCalculator.Deposite|number: "1.0":"en-US"}}
            </div>
          </div>
        </div>


      </div>
    </div>

  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>
      <span class="buy">{{"buy"|translate}}</span>
    </ng-template>
    <div class="d-flex justify-content-between" id="dark">
      <div class="market-trade-buy">




        <div class="row mt-4 mb-2">
          <div class="col-md-6">
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text" style="border-radius:5px">{{"portfolio"|translate}}</span>
              </div>
              <input style="border-radius:5px" name="ClientPortfolio" #ClientPortfolio [value]="marginCalculator.ClientPortfolio" class="form-control" disabled>
            </div>
          </div>

          <div class="col-md-6">
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text" style="border-radius:5px">{{"balance"|translate}}</span>
              </div>
              <input style="border-radius:5px" class="form-control" [(ngModel)]="marginCalculator.BookBalance" disabled>
            </div>
          </div>
        </div>
        <div class="row mt-4 mb-2">
          <div class="col-md-6">
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text" style="border-radius:5px">{{"margin"|translate}}%</span>
              </div>
              <input style="border-radius:5px" value="80" class="form-control" disabled>
            </div>
          </div>

          <div class="col-md-6">
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text" style="border-radius:5px">{{"required"|translate}}%</span>
              </div>
              <input style="border-radius:5px" [(ngModel)]="requiredBuy" class="form-control">

            </div>
          </div>
        </div>

        <button type="button" (click)="calculateBuy()" class="btn btn-success text-center mr-1">
          {{'calculate'|translate}}</button>
        <button type="button" class="btn btn-success text-center" (click)="resetCalculator()">
          {{'reset'|translate}}</button>
        <hr style="background: #6c757d!important;">

        <div class="row">
          <div class="col-md-8 d-flex flex-column">
            <div class="pb-1" style="font-weight:500; text-align: start;">
              {{'buy-limit'|translate}}
            </div>
          </div>
          <div class="col-md-4 d-flex flex-column">
            <div class="pb-1" style="text-align: end !important;">
              {{213468432168 |number: "1.0":"en-US"}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-tab>
</mat-tab-group>  -->

<div class="row font-family">
  <div class="col-1">
    <ul class="nav flex-column nav-tabs nav-justified" id="v-tab-tab" role="tablist" aria-orientation="vertical">
      <li class="height"><a class="nav-link active rotate text-danger" id="v-tab-home-tab" data-toggle="tab" href="#v-pills-home" role="tab" aria-controls="v-pills-home">{{"sell"|translate}}</a></li>
      <li class="height"> <a class="nav-link rotate text-success" id="v-tab-profile-tab" data-toggle="tab" href="#v-pills-profile" role="tab" aria-controls="v-pills-profile">{{"buy"|translate}}</a></li>
    </ul>
  </div>
  <div class="col-11">
    <div class="tab-content" id="v-pills-tabContent">
      <div class="tab-pane fade show active" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab">
        <div class="d-flex justify-content-between marginHeight" id="dark">
          <div class="market-trade-sell" style="height: 597 !important;">
            <div class="text-center">
              <circle-progress [percent]="marginPercentage" [radius]="100" [outerStrokeWidth]="20" [innerStrokeWidth]="10" [titleFontSize]="22" [titleColor]="isDarkTheme?'#ffffff':'black'" [outerStrokeColor]="circleColor" [subtitle]="'Margin'" [maxPercent]="9999" [subtitleColor]="isDarkTheme?'#ffffff':'black'" [unitsColor]="isDarkTheme?'#ffffff':'black'" [unitsFontSize]="22" [innerStrokeColor]="'#7f9fc1'" [animation]="true" [animationDuration]="300" [subtitleFontSize]="22"></circle-progress>
              <h5 *ngIf="textCircle == 1" class="text-center">{{"normal"|translate}}</h5>
              <h5 *ngIf="textCircle == 2" class="text-center">{{"accepted"|translate}}</h5>
              <h5 *ngIf="textCircle == 3" class="text-center">{{"margin-call"|translate}}</h5>
              <h5 *ngIf="textCircle == 4" class="text-center">{{"force-selling"|translate}}</h5>
            </div>
            <div class="row mt-4 mb-2">
              <div class="col-md-6">
                <div class="card background">
                  <h4>{{"book-balance"|translate}}</h4>
                  <h5>{{marginCalculator.marginCalculator.MarginBalance|number: '1.0'}}</h5>
                </div>
              </div>

              <div class="col-md-6">
                <div class="card background">
                  <h4>{{"portfolio"|translate}}</h4>
                  <h5>{{marginCalculator.marginCalculator.ClientPortfolio |number: '1.0'}}</h5>
                </div>
              </div>
            </div>
            <div class="row mt-4 mb-2">
              <div class="col-md-6">
                <div class="input-group mb-3">
                  <label for="customRange1" class="form-label">{{"required"|translate}} {{requiredSell}}%</label>
                  <input type="range" [min]="0" [max]="100" [value]="requiredBuy" [(ngModel)]="requiredSell" class="form-range" id="customRange1">
                </div>
              </div>
              <div class="col-md-6 pt-3">
                <div class="d-flex justify-content-between">
                  <button type="button" (click)="calculateSell()" class="btn btn-success text-center">
                    {{'calculate'|translate}}</button>
                  <button type="button" class="btn btn-success text-center" (click)="resetCalculator()">
                    {{'reset'|translate}}</button>
                </div>
              </div>
            </div>

            <hr class="" style="background: #6c757d!important;">

            <div class="row">
              <div class="col-md-8 d-flex flex-column">
                <div class="pb-1" style="font-weight:500; text-align: start;">
                  {{'sell-value'|translate}}
                </div>
                <div style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; text-align: start;">
                  {{'deposit-value'|translate}}
                </div>
              </div>
              <div *ngIf="marginObj == null" class="col-md-4 d-flex flex-column">
                <div class="pb-1" style="text-align: end !important;">
                  {{marginCalculator.Sell|number: "1.0":"en-US"}}
                </div>
                <div style="text-align: end !important;">
                  {{marginCalculator.Deposite|number: "1.0":"en-US"}}
                </div>
              </div>
              <div *ngIf="marginObj != null" class="col-md-4 d-flex flex-column">
                <div class="pb-1" style="text-align: end !important;">
                  {{marginObj.SellValue|number: "1.0":"en-US"}}
                </div>
                <div style="text-align: end !important;">
                  {{marginObj.DepositValue|number: "1.0":"en-US"}}
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>
      <div class="tab-pane fade" id="v-pills-profile" role="tabpanel" aria-labelledby="v-pills-profile-tab">
        <ng-template mat-tab-label>
          <span class="buy">{{"buy"|translate}}</span>
        </ng-template>
        <div class="d-flex justify-content-between" id="dark">
          <div class="market-trade-buy">

            <div class="text-center">
              <circle-progress [percent]="marginPercentage" [radius]="100" [outerStrokeWidth]="20" [innerStrokeWidth]="10" [outerStrokeColor]="circleColor" [subtitle]="'Margin'" [maxPercent]="9999" [subtitleColor]="isDarkTheme?'#ffffff':'black'" [unitsColor]="isDarkTheme?'#ffffff':'black'" [unitsFontSize]="22" [innerStrokeColor]="'#7f9fc1'" [animation]="true" [animationDuration]="300" [subtitleFontSize]="22"></circle-progress>
              <h5 *ngIf="textCircle == 1" class="text-center">{{"normal"|translate}}</h5>
              <h5 *ngIf="textCircle == 2" class="text-center">{{"accepted"|translate}}</h5>
              <h5 *ngIf="textCircle == 3" class="text-center">{{"margin-call"|translate}}</h5>
              <h5 *ngIf="textCircle == 4" class="text-center">{{"force-selling"|translate}}</h5>
            </div>
            <div class="row mt-4 mb-2">
              <div class="col-md-6">
                <div class="card background-grey">
                  <h4>{{"book-balance"|translate}}</h4>
                  <h5>{{marginCalculator.marginCalculator.MarginBalance|number: '1.0'}}</h5>
                </div>
              </div>

              <div class="col-md-6">
                <div class="card background-grey">
                  <h4>{{"portfolio"|translate}}</h4>
                  <h5>{{marginCalculator.marginCalculator.ClientPortfolio |number: '1.0'}}</h5>
                </div>
              </div>
            </div>
            <div class="row mt-4 mb-2">
              <div class="col-md-6">
                <div class="input-group mb-3">
                  <label for="customRange1" class="form-label">{{"required"|translate}} {{requiredBuy}}%</label>
                  <input type="range" [min]="0" [max]="100" [value]="requiredBuy" [(ngModel)]="requiredBuy" class="form-range" id="customRange1">
                </div>
              </div>
              <div class="col-md-6 pt-3">
                <div class="d-flex justify-content-between">
                  <button type="button" (click)="calculateBuy()" class="btn btn-success text-center">
                    {{'calculate'|translate}}</button>
                  <button type="button" class="btn btn-success text-center" (click)="resetCalculator()">
                    {{'reset'|translate}}</button>
                </div>
              </div>
            </div>


            <hr style="background: #6c757d!important;">

            <div class="row pt-3">
              <div class="col-md-8 d-flex flex-column">
                <div class="pb-1" style="font-weight:500; text-align: start;">
                  {{'buy-limit'|translate}}
                </div>
              </div>
              <div *ngIf="marginObj == null" class="col-md-4 d-flex flex-column">
                <div class="pb-1" style="text-align: end !important;">
                  {{marginCalculator.marginCalculator?.BuyLimit |number: "1.0":"en-US"}}
                </div>
              </div>
              <div *ngIf="marginObj != null" class="col-md-4 d-flex flex-column">
                <div class="pb-1" style="text-align: end !important;">
                  {{marginObj.BuyLimit |number: "1.0":"en-US"}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
